const SEO_CONSTANTS = {
    title: "CK DATA",
    description: "Data dashboard for viewing the metrics of the CyberKongz ecosystem.",
}

export default SEO_CONSTANTS;